import { render, staticRenderFns } from "./DialogDeleteExtract.vue?vue&type=template&id=550f471d"
import script from "./DialogDeleteExtract.vue?vue&type=script&lang=js"
export * from "./DialogDeleteExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports